import template from './myVacationsMobile.html';
import controller from './myVacationsMobile.controller';
import './myVacationsMobile.scss';

let myVacationsMobileComponent = {
  restrict: 'E',
  bindings: {
    userInceptionId: '<',
    onClickPeriodMobileListLink: '&'
  },
  template,
  controller
};

export default myVacationsMobileComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacationsMobile/myVacationsMobile.component.js